import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExportPdfService {
    savePdfFromBase64(base64String: string, fileName: string): void {
        try {
            const base64Content = base64String.replace(/^data:application\/pdf;base64,/, "");

            const byteCharacters = atob(base64Content);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName || 'document.pdf';

            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
            }, 100);
        } catch (error) {
        }
    }
}